export default __webpack_public_path__ + "static/media/bananas.bb0465b8.png";